// resources/js/components/CarouselComponent.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Requires a loader
import { Carousel } from 'react-responsive-carousel';
const BASE_URL = 'https://cdn.mgazeti.co.ke/image_uploads/';
function CarouselComponent() {
    const [booksIssues, setBooksIssues] = useState([]);
    const [moreIssues, setMoreIssues] = useState([]);

    useEffect(() => {
        // Replace with your API endpoint
        axios.get('/api/landing/carousel')
            .then(response => {
                if (response.data.success) {
                    setBooksIssues(response.data.data.booksIssues);
                    setMoreIssues(response.data.data.moreIssues);
                } else {
                    console.error('Error fetching the slides:', response.data.error);
                }
            })
            .catch(error => {
                console.error('There was an error fetching the slides!', error);
            });
    }, []);

    const replaceJpgWithWebp = (url) => {
        if (url.endsWith('.jpg')) {
            return url.replace('.jpg', '240.webp');
        }
        return url;
    };

    const renderSlides = (slides) => {
        if (!Array.isArray(slides)) {
            console.error('Slides is not an array:', slides);
            return null;
        }

        return slides.map((slide, index) => {
            const updatedUrl = replaceJpgWithWebp(slide.cover_image);
            return (
                <a key={index} className="" href={`/issue/${slide.slug}/details`}>
                    <img src={`${BASE_URL}${updatedUrl}`} alt={`Slide ${index + 1}`} className="width-f hgt100p" />
                    {/*<p className="legend">{slide.title}</p>*/}
                </a>
            );
        });
    };

    // const renderSlides = (slides) => {
    //     // console.log('Slides to render:', slides);
    //     return slides.map((slide, index) => {
    //         const updatedUrl = replaceJpgWithWebp(slide.cover_image);
    //         // console.log('Rendering slide:', index, slide, 'Updated URL:', updatedUrl);  // Logs each slide, index, and the updated URL
    //         return(
    //         <a key={index} className="" href={`/issue/${slide.slug}/details`}>
    //             <img key={index} src={`${BASE_URL}${updatedUrl}`} alt={`Slide ${index + 1}`} className="width-f hgt100p" />
    //             {/*<p className="legend">{slide.title}</p>*/}
    //         </a>
    //     )});
    // };

    return (
        <Carousel className="container-fluid pg0a">
            <div className="hero item">
                <div className="card border-0 bg-primary-1 p-3 rounded-0 ">
                    <div className="flex flex-row flex-align-space-between flex-vertical-center mx-0 w-100">
                        <div className="col-8 col-md-4 align-self-center text-white">
                            <h1 className="mg24b semi-bold">3000+ Free Children Books</h1>
                            <h2 className="font15px">Get to Enjoy and read <br/> Free children books <br/> anytime
                                anywhere.</h2>
                            <a href="/publication/all-children-books"
                               className="btn btn-dark rounded-0 px-3 mt-4">EXPLORE</a>
                        </div>
                        <div className="col-4 col-md-8 align-self-center">
                            <div className="image-row">
                                {renderSlides(booksIssues)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*<div className="hero item">*/}
            {/*    <div className="card border-0 bg-primary-1 p-3 rounded-0 ">*/}
            {/*        <div className="flex flex-row flex-align-space-between flex-vertical-center mx-0 w-100">*/}
            {/*            <div className="col-8 col-md-4 align-self-center text-white">*/}
            {/*                <h1 className="mg24b semi-bold">300+ Magazines</h1>*/}
            {/*                <h2 className="font15px">Get Latest Issues. Over 300+ <br/> Local and*/}
            {/*                    International <br/> Magazines</h2>*/}
            {/*                <a href="/category"*/}
            {/*                   className="btn btn-dark rounded-0 px-3 mt-4">EXPLORE</a>*/}
            {/*            </div>*/}
            {/*            <div className="col-4 col-md-8 align-self-center">*/}
            {/*                <div className="image-row">*/}
            {/*                    {renderSlides(moreIssues)}*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </Carousel>
    );
}

export default CarouselComponent;
